// https://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
export function dataURLtoBlob(dataurl) {
    if (!dataurl) return new Blob();

    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
}
